import { heroImages } from "@/mocks/landingData";
import { useScrollReveal } from "@/hooks/useScrollReveal";

export default function HeroSection() {
  const { ref, visible } = useScrollReveal({ threshold: 0.05 });

  return (
    <section
      id="hero"
      ref={ref}
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src={heroImages.heroBackground}
          alt="Active senior enjoying outdoor lifestyle with healthy joints"
          className="w-full h-full object-cover object-top"
          width={1600}
          height={900}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60" />
      </div>

      <div
        className={`relative z-10 w-full max-w-4xl mx-auto px-4 md:px-8 lg:px-12 pt-28 pb-16 text-center transition-all duration-600 ${
          visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"
        }`}
        style={{ transitionTimingFunction: "cubic-bezier(0.22, 0.61, 0.36, 1)" }}
      >
        <p className="text-accent-200 text-base md:text-lg font-medium tracking-[0.2em] uppercase mb-4">
          Premium Joint Health Editorial
        </p>
        <h1 className="font-heading text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6">
          Are Your Joints
          <br />
          Feeling Stiffer Than
          <br />
          They Used To?
        </h1>
        <p className="text-white/80 text-xl md:text-2xl leading-relaxed mb-8 max-w-2xl mx-auto">
          Discover what doctors and researchers are learning about joint
          lubrication, mobility, and the everyday comfort of staying active
          after 50.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-6 text-white/70 text-base">
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center">
              <i className="ri-time-line text-white/80" />
            </div>
            <span>4 min read</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center">
              <i className="ri-calendar-check-line text-white/80" />
            </div>
            <span>Updated this month</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center">
              <i className="ri-shield-star-line text-white/80" />
            </div>
            <span>Evidence-based</span>
          </div>
        </div>
      </div>
    </section>
  );
}